import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Plus } from "lucide-react";
import { Chapter, EASE, MaskedLine } from "../components/motion";
import { config } from "../config/siteConfig";

const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="bg-white text-[#08162B] py-24 lg:py-36"
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <Chapter index="09" label="Questions" />

        <h2 className="mt-10 font-display tracking-[0.02em] leading-[1.02] text-[clamp(2.2rem,5.5vw,4.5rem)]">
          <MaskedLine delay={0.1}>STRAIGHT ANSWERS.</MaskedLine>
        </h2>

        <div className="mt-14 border-t border-[#08162B]/10">
          {config.faqs.map((faq, i) => (
            <div key={faq.q} className="border-b border-[#08162B]/10">
              <button
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`faq-question-${i + 1}`}
                aria-expanded={open === i}
                className="group flex w-full items-center gap-5 sm:gap-8 py-6 sm:py-7 text-left"
              >
                <span className="font-mono text-[11px] tracking-[0.2em] text-[#5A6E85] w-7 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="flex-1 font-condensed text-lg sm:text-2xl text-[#08162B] group-hover:text-[#12294D] transition-colors duration-300">
                  {faq.q}
                </span>
                <Plus
                  size={20}
                  className={`shrink-0 text-[#08162B] transition-transform duration-300 ${
                    open === i ? "rotate-45" : ""
                  }`}
                />
              </button>
              <AnimatePresence initial={false}>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.45, ease: EASE }}
                    className="overflow-hidden"
                  >
                    <p
                      data-testid={`faq-answer-${i + 1}`}
                      className="pb-7 pl-12 sm:pl-[60px] pr-8 text-lg sm:text-xl leading-relaxed text-[#5A6E85] max-w-2xl"
                    >
                      {faq.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
